// actions/NoteTypes.js
export const CONFIRMED_GET_NOTES = "CONFIRMED_GET_NOTES";
export const CONFIRMED_CREATE_NOTE_ACTION = "CONFIRMED_CREATE_NOTE_ACTION";
export const CONFIRMED_SEND_DOCTOR_NOTE_REPLY = "CONFIRMED_SEND_DOCTOR_NOTE_REPLY";
